/**
 * Часы записи голоса с паузой — как в диктофоне (задача 6, 11.09.2026).
 *
 * ⚠️ СЧИТАЮТ ТОЛЬКО ЗАПИСЬ. До паузы длина бралась по стене — от «записать» до
 * «остановить». С паузой это враньё в опасную сторону: 4 секунды речи и 20 секунд
 * паузы прошли бы минимум в 5 секунд, а сервер отверг бы запись.
 *
 * ⚠️ ПО НАСТОЯЩИМ ЧАСАМ, А НЕ ПО ТИКАМ. Вкладка в фоне усыпляет таймеры, и счётчик
 * тиков отставал бы от реальной длины. Время передаётся снаружи (`Date.now()`) —
 * так часы проверяются без поддельных таймеров. Проверки — `recordingClock.test.ts`.
 */

export type RecordingState = 'idle' | 'recording' | 'paused' | 'stopped';

export type RecordingClock = {
  readonly state: RecordingState;
  start(now: number): void;
  pause(now: number): void;
  resume(now: number): void;
  stop(now: number): void;
  /** Сколько записано к моменту `now`, без пауз. */
  elapsedMs(now: number): number;
  /** Сколько осталось до предела задания; не меньше нуля. */
  remainingMs(maxMs: number, now: number): number;
};

export function createRecordingClock(): RecordingClock {
  let state: RecordingState = 'idle';
  /** Записанное в завершённых кусках. */
  let banked = 0;
  /** Начало текущего куска. */
  let since = 0;

  const elapsedMs = (now: number) => (state === 'recording' ? banked + (now - since) : banked);

  return {
    get state() {
      return state;
    },
    start(now) {
      state = 'recording';
      banked = 0;
      since = now;
    },
    pause(now) {
      if (state !== 'recording') return;
      banked += now - since;
      state = 'paused';
    },
    resume(now) {
      if (state !== 'paused') return;
      since = now;
      state = 'recording';
    },
    stop(now) {
      if (state === 'recording') banked += now - since;
      if (state === 'recording' || state === 'paused') state = 'stopped';
    },
    elapsedMs,
    remainingMs(maxMs, now) {
      return Math.max(0, maxMs - elapsedMs(now));
    },
  };
}
